import React, { useRef } from 'react';
import {
  Box,
  Heading,
  Flex,
  useDisclosure,
  Container,
  Spacer,
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
  Button,
  Drawer,
  HStack,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { ColorModeSwitcher } from '../ColorModeSwitcher';
import { Link as RouterLink } from 'react-router-dom';

const Header = props => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <Container
      maxW={{
        base: 'container.sm',
        md: 'container.md',
        lg: 'container.lg',
        xl: 'container.xl',
      }}
      flexDirection="row"
    >
      <Flex
        as="nav"
        align="center"
        wrap="wrap"
        color="current"
        {...props}
        pt={6}
        ph={{ base: 0, sm: 6 }}
      >
        <Box>
          <Button as={RouterLink} to="/" bg="transparent" pt={8} pb={8}>
            <Heading as="h1">reiFolio.</Heading>
          </Button>
        </Box>
        <Spacer />
        <HStack display={{ base: 'none', md: 'block' }}>
          <Button bg="transparent" as={RouterLink} to="/skills">
            Skills
          </Button>
          <Button bg="transparent" as={RouterLink} to="/projects">
            Projects
          </Button>
        </HStack>
        <ColorModeSwitcher size="md" />
        <Button
          bg="transparent"
          display={{ base: 'block', md: 'none' }}
          ref={btnRef}
          onClick={onOpen}
        >
          <HamburgerIcon size="100%" />
        </Button>

        <Drawer
          isOpen={isOpen}
          placement="top"
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Navigate</DrawerHeader>

            <DrawerBody>
              <HStack justifyContent="center">
                <Button
                  bg="transparent"
                  as={RouterLink}
                  to="/"
                  onClick={onClose}
                >
                  Home
                </Button>
                <Button
                  bg="transparent"
                  as={RouterLink}
                  to="/skills"
                  onClick={onClose}
                >
                  Skills
                </Button>
                <Button
                  bg="transparent"
                  as={RouterLink}
                  to="/projects"
                  onClick={onClose}
                >
                  Projects
                </Button>
              </HStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Flex>
    </Container>
  );
};

export default Header;
